var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import { AdditionalInfo } from "./AdditionalInfo";
export class DutchAdditionalInfo extends AdditionalInfo {
  constructor(_data) {
    super();
    /**
     */
    __publicField(this, "Kvk");
    /**
     */
    __publicField(this, "Rsin");
    /**
     * Adds support for polymorphism. The discriminator is the schema property
     * name that is used to differentiate between other schema that inherit this
     * schema.
     *
     * @protected
     * @type {string}
     * @memberof DutchAdditionalInfo
     */
    __publicField(this, "$type", "V1.Cesop.Psps.Extensions.DutchAdditionalInfo");
    if (_data) {
      for (const property in _data) {
        if (_data.hasOwnProperty(property)) {
          this[property] = _data[property];
        }
      }
    }
  }
  /**
   * Initializes a new model instance.
   */
  init(_data) {
    super.init(_data);
    if (_data) {
      this.Kvk = _data["Kvk"];
      this.Rsin = _data["Rsin"];
    }
    return this;
  }
  toJSON(_data) {
    _data = typeof _data === "object" ? _data : {};
    super.toJSON(_data);
    _data["Kvk"] = this.Kvk;
    _data["Rsin"] = this.Rsin;
    return _data;
  }
}
